import { FILTER_OPERATIONS } from '../constants/filterOperations';
import { filterAndSortingKeys } from './filterAndSortingsUtil';

export const getPaginationFilters = (filterKeys, item, defaultFilters) => {
  const itemFilters = paginationFilters[item];
  let filters = [...defaultFilters];

  if (itemFilters === null) {
    return filters;
  }

  for (const [key, value] of Object.entries(filterKeys)) {
    const newFilter = itemFilters[key](value);
    // We want to ensure, that if a filter is provided from filterKeys,
    // it should be the only one on that property
    filters = filters.filter(
      (filter) => filter.Property !== newFilter.Property,
    );
    filters.push(newFilter);
  }

  return filters;
};

export const paginationFilters = {
  hearings: {
    [filterAndSortingKeys.hearingStatus]: (value) => {
      return {
        Property: 'HearingStatus',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.hearingType]: (value) => {
      return {
        Property: 'HearingType',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.subjectArea]: (value) => {
      return {
        Property: 'SubjectArea',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.cityArea]: (value) => {
      return {
        Property: 'CityArea',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.hearingOwner]: (value) => {
      return {
        Property: 'HearingOwner',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.userHearingRole]: (value) => {
      return {
        Property: 'UserHearingRole',
        Operation: FILTER_OPERATIONS.EQUALS,
        Value: value,
      };
    },
    [filterAndSortingKeys.title]: (value) => {
      return {
        Property: 'Title',
        Operation: FILTER_OPERATIONS.CONTAINS,
        Value: value,
      };
    },
  },
};
